'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import I18n from 'I18n';
export function setTitle(title) {
  document.title = I18n.text(`pricingPage.windowTitles.${title}`);
}
export function resetTitle() {
  setTitle('default');
}
export function withDocumentTitle(WrappedComponent, title) {
  return props => {
    useEffect(() => {
      setTitle(title);
      return () => resetTitle();
    }, []);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
  };
}
export const useDocumentTitle = title => {
  useEffect(() => {
    setTitle(title);
    return () => resetTitle();
  }, [title]);
};